import type { ReactNode } from 'react';

export const symbol_navigation: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-252 207-128q-9.75 5-18.37 2.5Q180-128 174-133.89q-6-5.88-8.5-14.71-2.5-8.83 2.5-18.4l285-650q3.65-9 11.3-13.5 7.66-4.5 15.68-4.5t15.69 4.5Q503.35-826 507-817l285 650q5 9.57 2.5 18.4-2.5 8.83-8.5 14.71-6 5.89-14.62 8.39-8.63 2.5-18.38-2.5L480-252Zm-222 34 222-98 222 98-222-514-222 514Zm222-98Z"
		/>
	</svg>
);
